import { useEffect } from 'react';

export const useBarberPolling = ({
  user,
  activeTab,
  loadBarberData,
  loadBarberAcceptedQuickCuts,
  loadBarberQuickCutRequests
}) => {
  useEffect(() => {
    if (!user || user.user_type !== 'barber') return;
    if (activeTab === 'business') return;

    const barberInterval = setInterval(() => {
      if (typeof document !== 'undefined' && document.hidden) return;
      loadBarberData?.();
      loadBarberAcceptedQuickCuts?.();
    }, 8000);

    return () => clearInterval(barberInterval);
  }, [user, activeTab, loadBarberData, loadBarberAcceptedQuickCuts]);

  useEffect(() => {
    if (!user || user.user_type !== 'barber') return;
    if (activeTab !== 'requests') return;
    loadBarberQuickCutRequests?.();
    const requestsInterval = setInterval(() => {
      if (typeof document !== 'undefined' && document.hidden) return;
      loadBarberQuickCutRequests?.();
    }, 3000);
    return () => clearInterval(requestsInterval);
  }, [user, activeTab, loadBarberQuickCutRequests]);
};
